import { useTranslation } from "react-i18next";
import singleMode from "./filterBaseSingle";
import collatorSort from "utils/collatorSort";
import { preferencesNew } from "resources/data/preferencesNew";

const rawItems = [...preferencesNew[0].items];
const rawItemsNew = [
	...preferencesNew[0].items,
	...preferencesNew[1].items,
	...preferencesNew[2].items,
	...preferencesNew[3].items,
	...preferencesNew[4].items,
	...preferencesNew[5].items,
];

export { rawItems, rawItemsNew };

export const isValidInQuery = (value) => {
	if (value === "") {
		return true;
	}
	const validValuesArray = rawItemsNew.map((item) => item.key);
	const valueAsNumber = Number(value);

	return (
		Number.isInteger(valueAsNumber) &&
		validValuesArray.includes(valueAsNumber)
	);
};

export const isValidInParam = (value) => {
	if (value === "" || value === undefined || value === null) {
		return true;
	}
	const validValuesArray = rawItemsNew.map((item) => item.code);

	return validValuesArray.includes(value);
};

export const compute = {
	valueToApiParam: (value) => {
		const current = rawItemsNew.find((item) => item.value === value);
		return current ? current.value : null;
	},
	urlToApiParam: (value) => {
		if (!value) return null;
		const current = rawItemsNew.find(({ code }) => code === value)?.key;
		return Number(current);
	},
	queryUrlToApiParam: (queryUrl) => {
		if (!queryUrl) return null;
		const current = rawItemsNew.find(
			({ key }) => key === Number(queryUrl)
		)?.key;
		return Number(current) ?? null;
	},
	valueToUrl: (value) => {
		const current = rawItemsNew.find(({ key }) => key === value)?.code;
		return current ?? "";
	},
	valueToQueryUrl: (value) => {
		const current = rawItemsNew.find(
			({ key }) => key === Number(value)
		)?.key;
		return current ?? "";
	},
	urlToValue: (url) => {
		const current = rawItemsNew.find(({ code }) => code === url)?.key;
		return current ?? null;
	},
	queryUrlToValue: (queryUrl) => {
		const current = rawItemsNew.find(
			({ key }) => key === Number(queryUrl)
		)?.key;
		return current ?? null;
	},
	queryUrlToUrl: (queryUrl) => {
		const current = rawItemsNew.find(
			({ key }) => key === Number(queryUrl)
		)?.code;
		return current ?? "";
	},
};

const useFilterPreferences = ({ initial, isNewPreferences = false }) => {
	const { t } = useTranslation(["filtersAndSelectors"]);

	const items = isNewPreferences
		? rawItemsNew.map((item) => ({
				content: t(`filtersAndSelectors:preferences.${item.key}`),
				value: item.key,
				selected: !(initial === item.key),
				meta: {
					url: item.code,
					value: item.key,
				},
		  }))
		: rawItems.map((item) => ({
				content: t(`filtersAndSelectors:preferences.${item.key}`),
				value: item.key,
				selected: !(initial === item.key),
				meta: {
					url: item.code,
					value: item.key,
				},
		  }));

	const sortedItems = collatorSort(
		collatorSort(items, "content"),
		"selected"
	);

	return {
		rawItems,
		items: sortedItems,
		compute,
		isValidInQuery,
		...singleMode({ items: sortedItems, initial, compute }),
	};
};

export default useFilterPreferences;
